let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jRR8D")).then(() => parcelRequire('eoxiv'));